export default function authReducer(state = {
    emailExistErr: false,
    SIGNATURE_EXPIRED: "",
}, action) {
    switch (action.type) {
        case "EMAIL_EXIST":
            return {
                ...state,
                emailExistErr: action.payload
            }
        case "SIGNATURE_EXPIRED":
            return {
                ...state,
                SIGNATURE_EXPIRED: action.payload
            }
        case "VALIDATE_OTP_SUCCESS":
            return {
                ...state,
                details: {
                    token: action.payload?.token,
                    UUID: action.payload?.user?.uuid
                }
            }
        default: return state
    }

}
